'use strict';

+function ($) {

  $.fn.checkbox = function () {
    // handle checkboxes wrapped in labels (without for="#id") on page load
    return this
    .find('label :checkbox')
    .addBack('label :checkbox')
    .each(function () {
      $(this).closest('label').toggleClass('checked', $(this).is(':checked'));
      $(this).closest('label').toggleClass('disabled', $(this).is(':disabled'));
    });
  };

  $(document)
  // update checkbox label on change
  .on('change.bc.checkbox', 'label input:checkbox', function (e) {
    var $input = $(e.target);
    var $label = $input.closest('label');
    $label.toggleClass('checked', $input.is(':checked'));
  });

  basecoat.init.checkbox = function () {
    $(this).checkbox();
  };

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/checkbox.js
// module id = 3
// module chunks = 0